var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getDefaultDateFormat, getAllOptionChainExpiryListWithCaching, getExpiryDateOptionChainWithCaching, getSymbols, getNearestExpDataOptionChain, } from "../../utils/methods";
import SearchModal from "../dashboard/option-chain/search-modal";
import styles from "./search-expiry.module.scss";
import moment from "moment";
import { EXCHANGE_TYPE_B, EXCHANGE_TYPE_N, SENSEX, BANKEX, TV_5P_URL, } from "src/utils/constant";
import { v4 as uuid } from "uuid";
import { useAppSelector } from "src/hooks/redux";
const SearchExpiry = (props) => {
    const getIndiceForOc = () => {
        let tempIndiceArray;
        if (!props.isFullScreenView) {
            if (props.selectedScript == "SENSEX" ||
                props.selectedScript == "MIDCPNIFTY") {
                tempIndiceArray = ["NIFTY", "BANKNIFTY", props.selectedScript];
            }
            else {
                tempIndiceArray = ["NIFTY", "BANKNIFTY", "FINNIFTY"];
            }
        }
        else if (props.isFullScreenView && !props.isMultiple) {
            tempIndiceArray = [
                "NIFTY",
                "BANKNIFTY",
                "FINNIFTY",
                // "SENSEX",
                "MIDCPNIFTY",
            ];
        }
        else if (props.isFullScreenView && props.isMultiple) {
            if (props.selectedScript == "SENSEX" ||
                props.selectedScript == "MIDCPNIFTY") {
                tempIndiceArray = ["NIFTY", "BANKNIFTY", props.selectedScript];
            }
            else {
                tempIndiceArray = ["NIFTY", "BANKNIFTY", "FINNIFTY"];
            }
        }
        return tempIndiceArray;
    };
    // let tempSearchText;
    const [expiries, setExpiries] = useState([]);
    const searchModalRef = useRef();
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [scripts, setScripts] = useState([]);
    const [searchList, setSearchList] = useState(scripts);
    const [searchText, setSearchText] = useState(props.selectedScript);
    const [tempSearchText, setTempSearchText] = useState(props.selectedScript);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [futExpiry, setFutExpiry] = useState([]);
    // const singleExpiryRef = useRef("");
    const [isOptionSymbolLoading, setOptionSymbolLoading] = useState(true);
    const searchUIDRef = useRef(uuid());
    const [indiceArray, setIndiceArray] = useState(getIndiceForOc());
    const stockList = useAppSelector((state) => state.modals.stockList);
    useEffect(() => {
        setIndiceArray(getIndiceForOc());
    }, [props.isMultiple]);
    const fetchScripts = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            // let scriptData = await getSymbols();
            let scriptData = stockList.status === "ON" ? stockList.scripList : yield getSymbols();
            if (props.hideFinNifty) {
                scriptData = scriptData.filter((singleSymbol) => {
                    return singleSymbol != "FINNIFTY";
                });
            }
            if (props.hideSensex) {
                scriptData = scriptData.filter((singleSymbol) => {
                    return singleSymbol != SENSEX;
                });
            }
            if (props.hideMidCpBankex) {
                scriptData = scriptData.filter((singleSymbol) => {
                    return singleSymbol != "MIDCPNIFTY";
                });
            }
            // Hiding BANKEX
            if (props.hideMidCpBankex) {
                scriptData = scriptData.filter((singleSymbol) => {
                    return singleSymbol != "BANKEX";
                });
            }
            setScripts(scriptData);
            setSearchList(scriptData);
        }
        catch (err) {
            console.error(err);
        }
    }), [stockList]);
    useEffect(() => {
        stockList.status === "ON" && fetchScripts();
    }, [stockList]);
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const checkIfClickedOutside = (e) => {
            if (showSearchModal &&
                searchModalRef.current &&
                !searchModalRef.current.contains(e.target)) {
                setShowSearchModal(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [showSearchModal]);
    useEffect(() => {
        return () => {
            //unmount cleanup
            searchModalRef.current = undefined;
        };
    }, []);
    const onSearchClick = useCallback(() => {
        fetchScripts();
        if (!showSearchModal) {
            setShowSearchModal(true);
        }
    }, [showSearchModal]);
    useEffect(() => {
        if (props.selectedScript) {
            if (props.selectedScript == "NIFTY" ||
                props.selectedScript == "BANKNIFTY" ||
                props.selectedScript == "FINNIFTY" ||
                props.selectedScript == "SENSEX" ||
                props.selectedScript == "MIDCPNIFTY") {
                setSearchText("");
                setTempSearchText("");
            }
            // else if (
            //   props.selectedScript == "SENSEX" ||
            //   props.selectedScript == "MIDCPNIFTY"
            // ) {
            //   setSearchText("");
            //   setTempSearchText(props.selectedScript);
            // }
            else {
                setSearchText(props.selectedScript);
                setTempSearchText(props.selectedScript);
            }
        }
    }, [props.selectedScript]); //script Change
    const onSearch = useCallback((val) => {
        const update = scripts === null || scripts === void 0 ? void 0 : scripts.filter((item) => {
            return item.toLowerCase().includes(val.toLowerCase());
        });
        setSearchText(val);
        setSearchList(update);
    }, [scripts]);
    const onSelect = (item) => {
        setShowSearchModal(false);
        // if (!props.isOcIframe) {
        if (item === "NIFTY" || item === "BANKNIFTY" || item === "FINNIFTY") {
            setSearchText("");
        }
        else {
            setSearchText(item);
            setTempSearchText(item);
        }
        const update = scripts === null || scripts === void 0 ? void 0 : scripts.filter((data) => {
            return data.toLowerCase().includes(item.toLowerCase());
        });
        setSearchList(update);
        if (isEmpty(props.selectedScript) || props.selectedScript != item) {
            setExpiries([]);
            // singleExpiryRef.current = "";
            props.selectedExpiryCallback(undefined);
            props.selectedScriptCallback(item);
        }
        showIndexUpfront(item);
        // } else {
        // const newUrl = `?symbol=${encodeURIComponent(item)}`;
        // navigate(newUrl);
        if (props.isOcIframe) {
            window.parent.postMessage({ actionType: `${item} searched`, data: { searchTerm: `${item}` } }, `${TV_5P_URL}`);
        }
        // }
        showIndexUpfront(item);
    };
    const fetchnewOptionChainList = useCallback((callFoScrip) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        try {
            const exchange = callFoScrip.toUpperCase() == SENSEX ||
                callFoScrip.toUpperCase() == BANKEX
                ? EXCHANGE_TYPE_B
                : EXCHANGE_TYPE_N;
            setOptionSymbolLoading(true);
            let nearestExpiry = [];
            let optionsResp = [];
            let respArray;
            // setOptionSymbolLoading(true);
            const optionChainDataSet = yield getAllOptionChainExpiryListWithCaching(callFoScrip, exchange, "D", searchUIDRef.current);
            //console.log(optionChainDataSet, "SEARCH COMPONENT LEVEL ERROR");
            if (
            // optionChainDataSet.Status == "cancelled" ||
            optionChainDataSet.sortOptionChainData === null ||
                optionChainDataSet.sortOptionChainData === undefined ||
                ((_a = optionChainDataSet.sortOptionChainData) === null || _a === void 0 ? void 0 : _a.length) === 0) {
                setOptionSymbolLoading(false);
                return;
            }
            else {
                const searchFNOResp = optionChainDataSet.futExpiry; //remove
                optionsResp = optionChainDataSet.sortOptionChainData;
                let splitExpiryString;
                if (props.selectedExpiry !== "") {
                    splitExpiryString = props.selectedExpiry.split("(");
                }
                else {
                    if (optionChainDataSet.filterList)
                        splitExpiryString =
                            optionChainDataSet.filterList[0].ExpiryDate.split("(");
                }
                const timeString = splitExpiryString[1].split("+")[0];
                nearestExpiry = getNearestExpDataOptionChain(searchFNOResp, props.selectedScript, timeString);
                props.selectedExpiryCallback(undefined);
                setExpiries([]);
                const expiriesList = optionChainDataSet.filterList;
                if (expiriesList) {
                    setExpiries(expiriesList);
                }
                (_b = props.expiriesCallback) === null || _b === void 0 ? void 0 : _b.call(props, props.selectedScript, expiriesList);
                setFutExpiry(searchFNOResp);
                (_c = props.optionsCallback) === null || _c === void 0 ? void 0 : _c.call(props, nearestExpiry, optionsResp, optionChainDataSet.lastrate, optionChainDataSet.filterList, searchFNOResp);
                setOptionSymbolLoading(false);
            }
        }
        catch (err) {
            console.error(err);
        }
        finally {
            // setOptionSymbolLoading(false);
        }
    }), [props.selectedScript, props.selectedExpiry, props.optionsCallback]);
    const fetchOptionsForExpiry = useCallback((expiryDate) => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        try {
            const exchange = props.selectedScript.toUpperCase() == SENSEX
                ? EXCHANGE_TYPE_B
                : EXCHANGE_TYPE_N;
            let nearestExpiry = [];
            let optionsResp = [];
            setOptionSymbolLoading(true);
            const expirydateChange = moment(expiryDate).format("YYYY-MM-DD");
            const optionChainDataSet = yield getExpiryDateOptionChainWithCaching(props.selectedScript, exchange, "D", //change from props
            expirydateChange, searchUIDRef.current);
            optionsResp = optionChainDataSet.sortOptionChainData;
            let splitExpiryString;
            // const timeString = props.selectedExpiry.split("+")[0];
            if (expiryDate !== "") {
                splitExpiryString = expiryDate.split("(");
            }
            else {
                if (futExpiry)
                    splitExpiryString = futExpiry[0].ExpiryDate.split("(");
            }
            const timeString = splitExpiryString[1].split("+")[0];
            nearestExpiry = getNearestExpDataOptionChain(futExpiry, props.selectedScript, timeString);
            (_d = props.optionsCallback) === null || _d === void 0 ? void 0 : _d.call(props, nearestExpiry, optionsResp, optionChainDataSet.lastrate, expiries, futExpiry);
            setOptionSymbolLoading(false);
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setOptionSymbolLoading(false);
        }
    }), [props.selectedScript, props.selectedExpiry, props.optionsCallback]);
    useEffect(() => {
        var _a;
        if (props.loadingCallback) {
            (_a = props.loadingCallback) === null || _a === void 0 ? void 0 : _a.call(props, isOptionSymbolLoading);
        }
    }, [isOptionSymbolLoading]);
    useEffect(() => {
        if (props.callSearchFoScripApi ||
            props.callOptionsFromSymbolApi
        // &&
        //!checkIsEmpty(props.selectedExpiry)
        ) {
            fetchnewOptionChainList(props.selectedScript);
        }
    }, [
        props.selectedScript,
        // props.refresh,
    ]);
    useEffect(() => {
        //console.log(props.selectedExpiry, "selected");
        if (props.selectedExpiry) {
            fetchOptionsForExpiry(props.selectedExpiry);
        }
    }, [props.refresh]);
    const showIndexUpfront = (scrip) => {
        if (props.isMultiple || !props.isFullScreenView) {
            if (scrip == "FINNIFTY" || scrip == "SENSEX" || scrip == "MIDCPNIFTY") {
                const tempIndiceArray = [...indiceArray];
                tempIndiceArray.splice(-1, 1, scrip);
                setIndiceArray(tempIndiceArray);
            }
        }
    };
    return (_jsxs("div", Object.assign({ className: `${styles.niftyBankniftyPanel} ${(!props.isFullScreenView || props.isMultiple) &&
            props.triggeredFrom == "miniOC" &&
            styles.niftyBankniftyPanelSmall}` }, { children: [_jsxs("div", Object.assign({ className: `${styles.selectTag} medium` }, { children: [indiceArray.map((index, i) => {
                        if (index == "FINNIFTY" && props.hideFinNifty)
                            return _jsx(_Fragment, {});
                        else {
                            return (_jsx("span", Object.assign({ className: `${(props === null || props === void 0 ? void 0 : props.selectedScript) == index ? styles.active : ""}`, onClick: () => {
                                    // if (!props.isOcIframe) {
                                    if ((props === null || props === void 0 ? void 0 : props.selectedScript) != index) {
                                        setExpiries([]);
                                        props.selectedExpiryCallback(undefined);
                                        props.selectedScriptCallback(index);
                                    }
                                    // }
                                    // else {
                                    // const newUrl = `?symbol=${encodeURIComponent(index)}`;
                                    // navigate(newUrl);
                                    if (props.isOcIframe) {
                                        window.parent.postMessage({
                                            actionType: `${index} searched`,
                                            data: { searchTerm: `${index}` },
                                        }, `${TV_5P_URL}`);
                                    }
                                    // }
                                } }, { children: index.toUpperCase() }), `${i}`));
                        }
                    }), !props.hideFinNifty &&
                        (props.isMultiple || !props.isFullScreenView) && (_jsxs("div", Object.assign({ className: `${styles.selectTagHoverWrapper} medium` }, { children: [_jsx("span", Object.assign({ className: `${(props === null || props === void 0 ? void 0 : props.selectedScript) == "NIFTY" ? styles.active : ""}`, onClick: () => {
                                    if ((props === null || props === void 0 ? void 0 : props.selectedScript) != "NIFTY") {
                                        setExpiries([]);
                                        props.selectedExpiryCallback(undefined);
                                        props.selectedScriptCallback("NIFTY");
                                    }
                                } }, { children: "Nifty" })), _jsx("span", Object.assign({ className: `${(props === null || props === void 0 ? void 0 : props.selectedScript) == "BANKNIFTY" ? styles.active : ""}`, onClick: () => {
                                    if ((props === null || props === void 0 ? void 0 : props.selectedScript) != "BANKNIFTY") {
                                        setExpiries([]);
                                        props.selectedExpiryCallback(undefined);
                                        props.selectedScriptCallback("BANKNIFTY");
                                    }
                                } }, { children: "BANKNIFTY" })), _jsx("span", Object.assign({ className: `${(props === null || props === void 0 ? void 0 : props.selectedScript) == "FINNIFTY" ? styles.active : ""}`, onClick: () => {
                                    if ((props === null || props === void 0 ? void 0 : props.selectedScript) != "FINNIFTY") {
                                        setExpiries([]);
                                        props.selectedExpiryCallback(undefined);
                                        props.selectedScriptCallback("FINNIFTY");
                                        showIndexUpfront("FINNIFTY");
                                    }
                                } }, { children: "FINNIFTY" })), _jsx("span", Object.assign({ title: "MIDCAP NIFTY", className: `${(props === null || props === void 0 ? void 0 : props.selectedScript) == "MIDCPNIFTY" ? styles.active : ""}`, onClick: () => {
                                    if ((props === null || props === void 0 ? void 0 : props.selectedScript) != "MIDCPNIFTY") {
                                        setExpiries([]);
                                        props.selectedExpiryCallback(undefined);
                                        props.selectedScriptCallback("MIDCPNIFTY");
                                        showIndexUpfront("MIDCPNIFTY");
                                    }
                                } }, { children: "MIDCPNIFTY" }))] })))] })), _jsxs("div", Object.assign({ ref: searchModalRef, className: `${styles.searchBox} ${(showSearchModal && !props.isFullScreenView) ||
                    (showSearchModal && props.isMultiple)
                    ? styles.expand
                    : "null"}` }, { children: [_jsx("img", { src: "https://images.5paisa.com/fno/assets/svgs/search.svg", alt: "searchIcon" }), _jsx("input", { type: "search", onClick: onSearchClick, onChange: (event) => {
                            onSearch(event.target.value);
                            setTempSearchText(event.target.value);
                        }, placeholder: "Search Scrip", value: tempSearchText, title: tempSearchText }), showSearchModal && (_jsx(SearchModal, { selectedScript: props.selectedScript, flag: tempSearchText, hideFinNifty: props.hideFinNifty, list: searchList, onSelect: (item) => {
                            onSelect(item);
                        } }))] })), _jsx("select", Object.assign({ className: `${styles.selectBox} form-select small`, onChange: (e) => {
                    props.selectedExpiryCallback(e);
                    fetchOptionsForExpiry(e.target.value);
                } }, { children: expiries.length > 0 ? (expiries.map((expiry) => {
                    return (_jsx("option", Object.assign({ selected: expiry.ExpiryDate == props.selectedExpiry ? true : false, value: expiry.ExpiryDate }, { children: getDefaultDateFormat(expiry.ExpiryDate) }), expiry.ExpiryDate));
                })) : (_jsx("option", Object.assign({ selected: true }, { children: "Loading..." }))) }))] })));
};
export default SearchExpiry;
